import { render, staticRenderFns } from "./ListUserGroups.vue?vue&type=template&id=978f534e&"
import script from "./ListUserGroups.vue?vue&type=script&lang=js&"
export * from "./ListUserGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('978f534e')) {
      api.createRecord('978f534e', component.options)
    } else {
      api.reload('978f534e', component.options)
    }
    module.hot.accept("./ListUserGroups.vue?vue&type=template&id=978f534e&", function () {
      api.rerender('978f534e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/lists/components/ListUserGroups.vue"
export default component.exports